(function () {

    'use strict';
    angular.module('app').controller('thirdPartyCredentialsController', ['$uibModalInstance', '$sce', 'thirdPartyCredentialsService', 'args', thirdPartyCredentialsController]);

    function thirdPartyCredentialsController($uibModalInstance, $sce, thirdPartyCredentialsService, args) {

        var vm = this;
        vm.providerProperties = [];
        vm.properties = {};
        vm.submitted = false;
        vm.isCreate = args.isCreate;
        vm.selectedThirdParty = null;
        vm.crmCredentialsForm = null;
        vm.working = false;

        vm.providerSelected = providerSelected;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.getValidProperties = getValidProperties;

        function setup() {
            thirdPartyCredentialsService.getThirdParties().then(function (x) {
                vm.thirdParties = x;

                if (!vm.isCreate) {
                    vm.name = args.credentials.name;

                    var i;
                    for (i = 0; i < vm.thirdParties.length; i++) {
                        if (vm.thirdParties[i].type === args.credentials.thirdPartyType) {
                            vm.selectedThirdParty = vm.thirdParties[i];
                            providerSelected();
                        }
                    }

                    for (i = 0; i < vm.providerProperties.length; i++) {
                        if (vm.providerProperties[i].infoText) {
                            vm.providerProperties[i].infoText = $sce.trustAsHtml(vm.providerProperties[i].infoText + '');
                        }

                        if (vm.providerProperties[i].type.toLowerCase() === 'boolean') {
                            vm.properties[vm.providerProperties[i].name] =
                                args.credentials.properties[camelize(vm.providerProperties[i].name)].toLowerCase() === 'true';
                        } else if (vm.providerProperties[i].type.toLowerCase() === 'integer') {
                            parseInt(vm.properties[vm.providerProperties[i].name] =
                                parseInt(args.credentials.properties[camelize(vm.providerProperties[i].name)]));
                        }
                        else {
                            vm.properties[vm.providerProperties[i].name] =
                                args.credentials.properties[camelize(vm.providerProperties[i].name)];
                        }
                    }
                }
            });
        }
            

        function camelize(str) {
            return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replace(/\s+/g, '');
        }

        function providerSelected() {
            vm.submitted = false;
            vm.providerProperties = vm.selectedThirdParty.properties;

            for (var i = 0; i < vm.providerProperties.length; i++) {
                if (vm.providerProperties[i].type.toLowerCase() === 'boolean') {
                    vm.properties[vm.providerProperties[i].name] = false;
                }
            }
        }

        function submit() {
            vm.submitted = true;
            vm.working = true;

            if (!vm.crmCredentialsForm.$valid) {
                vm.working = false;
                return;
            }

            if (vm.isCreate) {
                var createRequest = {
                    companyId: args.companyId,
                    name: vm.name,
                    thirdPartyType: vm.selectedThirdParty.type,
                    properties: vm.properties
                };

                thirdPartyCredentialsService.create(createRequest).then(
                    function () {
                        $uibModalInstance.close();
                    },
                    function (error) {
                        vm.working = false;
                        vm.errorMessage = error.message;
                    }
                );
            } else {
                var updateRequest = {
                    id: args.credentials.credentialsId,
                    name: vm.name,
                    thirdPartyType: args.credentials.thirdPartyType,
                    properties: vm.properties
                };

                thirdPartyCredentialsService.update(updateRequest).then(
                    function () {
                        $uibModalInstance.close();
                    },
                    function (error) {
                        vm.working = false;
                        vm.errorMessage = error.message;
                    }
                );
            }
        }

        function cancel() {
          $uibModalInstance.dismiss('cancel');
        }

        function getValidProperties() {
            var properties = [];

            for (var i = 0; i < vm.providerProperties.length; i++) {
                var property = vm.providerProperties[i];

                if (!property.condition) {
                    properties.push(property);
                } else {
                    var value = vm.properties[property.condition.sourceProperty];
                    if (value) {
                        switch (property.condition.operator) {
                            case 0: //In
                                var values = property.condition.value.toLowerCase().trim().split(/\s*,\s*/);
                                if (values.includes(value.toLowerCase())) {
                                    properties.push(property);
                                }
                                break;
                        }
                    }
                }
            }

            return properties;
        }

        setup();
    }
})();